import { ArrowRight } from "lucide-react";
import { FadeIn } from "@/components/Reveal";

export const Readiness = () => (
  <section id="readiness" className="noise-dark relative bg-navy py-24 text-white lg:py-36">
    <div className="container-tsm relative flex flex-col items-center text-center">
      <FadeIn>
        <p className="eyebrow justify-center">Business Readiness</p>
        <h2
          className="mx-auto mt-8 max-w-5xl font-serif text-4xl font-semibold leading-[1.06] tracking-tight sm:text-6xl lg:text-7xl"
          data-testid="readiness-headline"
        >
          Is Your Business Ready When Someone Asks for{" "}
          <span className="italic text-gold">Proof?</span>
        </h2>
      </FadeIn>

      <FadeIn delay={0.15}>
        <p className="mx-auto mt-9 max-w-3xl text-base leading-relaxed text-white/70 lg:text-lg" data-testid="readiness-copy-1">
          Policies, licenses, employee records, verification documents, contracts, testing records, onboarding
          procedures, and operational processes are easy to overlook until they are suddenly needed.
        </p>
      </FadeIn>
      <FadeIn delay={0.25}>
        <p className="mx-auto mt-5 max-w-3xl text-base leading-relaxed text-white/70 lg:text-lg" data-testid="readiness-copy-2">
          TSM Group CLE helps businesses build systems before an inspection, audit, client request, employee issue, or
          compliance problem forces the conversation.
        </p>
      </FadeIn>

      <FadeIn delay={0.35}>
        <a href="#request" data-testid="readiness-cta" className="btn-gold mt-11">
          Improve Your Business Readiness
          <ArrowRight className="h-4 w-4" />
        </a>
      </FadeIn>
    </div>
  </section>
);
